import { render } from "./Log.vue?vue&type=template&id=9867d760&scoped=true"
import script from "./Log.vue?vue&type=script&lang=js"
export * from "./Log.vue?vue&type=script&lang=js"

import "./Log.vue?vue&type=style&index=0&id=9867d760&scoped=true&lang=css"
import "./Log.vue?vue&type=style&index=1&id=9867d760&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9867d760"]])

export default __exports__